import { render } from "./TopBar.vue?vue&type=template&id=440c8bff"
const script = {}

import "./TopBar.vue?vue&type=style&index=0&id=440c8bff&lang=scss"

import exportComponent from "C:\\Users\\MK\\Desktop\\paymentapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__